/** @format */

import React from 'react';
import man from '../images/main/Img.png';
import '../credit.css';
import { PrimaryAction } from './hero/BackgroundAsImage';
import svg from '../images/main/Group.svg';

export const Credit = () => {
	return (
		<>
			<section id="credit-section">
				<div className="credit-content">
					<div className="credit-text">
						<section>
							<h1> Get a Free Credit Audit Report</h1>
							<p>
								Renoix team will work with all three credit bureaus and challanges all negative entries
								and mistakes on your behalf. These bureaus have 30 days to verify each item. If they
								cannot prove it, they must remove it.
							</p>
						</section>
						<section className="list-section">
							<h2 className="small-heading">You will reciceve:</h2>
							<ul className="credit-list">
								<li className="tick">
									<span>
										<img src={svg} alt="" />
										FREE credit consultation
									</span>
								</li>{' '}
								<li className="tick">
									<span>
										<img src={svg} alt="" />
										FREE credit recommendations
									</span>
								</li>{' '}
								<li className="tick">
									<span>
										<img src={svg} alt="" />
										FREE in-depth credit analysis
									</span>
								</li>
							</ul>
						</section>
						<a href="#form">
							<PrimaryAction>Get a Free Credit Audit</PrimaryAction>
						</a>
					</div>
					<div className="credit-image">
						<img src={man} alt="" />
					</div>
				</div>
			</section>
		</>
	);
};
